import { cloneDeep } from 'lodash-es'
import { allCodesPath } from '@/lib/codes'
import type { CodeWithCategoryAndChildren } from '@/api/generated/v2'
import type { V1GroupsUsersResponse } from '@/ContextTab/stores/groupsAndUsers'


// Objects of this type must only be used in legacy!
type CodeSpoiled = Omit<CodeWithCategoryAndChildren, 'children'> & {
  track?: number[]
  pos?: number
  children: (CodeSpoiled | number)[] // ☢️ number, Карл! Objects->ids
}

// Input:
// смысл: проставить айтему track и pos
function processCodeItem(
  item: CodeSpoiled,
  items: Record<number, CodeSpoiled>,
  parent: CodeSpoiled | null,
  pos: number,
): Record<number, CodeSpoiled> {
  items[item.id] = item

  if (parent) {
    item.track = [...parent.track ?? []]
    item.track.push(parent.id)
  } else {
    item.track = []
  }

  item.pos = pos++

  if (item.children) {
    const children: number[] = []
    item.children.forEach((childItem) => {
      if (typeof childItem !== 'number') {
        processCodeItem(childItem, items, item, pos++)
        children.push(childItem.id)
      }
    })
    item.children = children // Objects->ids !!! 🤦
  }

  return items
}

export function processCodesForLegacy(codes: any[] | any) {

  codes = cloneDeep(codes) // for not to spoil original objects

  const codesTree = Array.isArray(codes)
    ? {
        id: '-1',
        children: codes,
        path: allCodesPath,
        pos: -1,
      }
    : codes

  // I removed normalizeChildrenByTrack here,
  // because in legacy it should be called inside tree component
  // (and it looks like a fix)
  return processCodeItem(codesTree, {}, null, 0)
}

export function prepareCanvasCodes(
  creationProfileCodes: CodeWithCategoryAndChildren[] | null,
  pubProfileCodes: CodeWithCategoryAndChildren[] | null,
) {
  const canvasCodes = processCodesForLegacy([
    {
      id: -3,
      name: 'Публикующие коды',
      children: pubProfileCodes ?? [],
      path: allCodesPath,
    },
    {
      id: -2,
      name: 'Не публикующие коды',
      children: creationProfileCodes ?? [],
      path: allCodesPath,
    },
  ])

  // remove virtual root, otherwise it will add a node at root level in tree when displayed
  // (it's a hack, it works because there's a data transformation in VirtualTree in legacy)
  delete canvasCodes[-1]

  return canvasCodes
}

// from legacy/.../dataProcessor/dataHandlers.js, which was called in api/interceptors/response
export function processGroupsAndUsersForLegacy(groupsAndUsers: V1GroupsUsersResponse) {
  groupsAndUsers = cloneDeep(groupsAndUsers)

  const items = {}
  let pos = 0
  const adminGroups: any[] = []

  function addUser(user, track) {
    if (!items[user.id]) {
      user.track = track
      user.pos = pos++
      user.isUser = true
      user.children = []
      items[user.id] = user
    }
  }

  groupsAndUsers.groups_with_users?.forEach((item) => {
    if (!item.users.length) {
      return
    }

    const newItem = {
      ...item as any,
      track: [0],
      pos: pos++,
      isGroup: true,
      id: item.id + 'G',
      children: [...item.users.map((user) => user.user.id)],
    }

    // Пользователей, состоящих в нескольких группах, добавляем с первой из почтовых групп, в которой они состоят.
    // Этот приоритет необходим для правильного отображения в компоненте legacy::PbVirtualTree 💩
    if (newItem.is_mail) {
      newItem.users.forEach(({ user }) => addUser(user, [0, newItem.id]))
      delete newItem.users
      items[newItem.id] = newItem
    } else {
      // Административные группы не добавляем, но собираем отдельно и берем из них только тех пользователей,
      // которые не состоят ни в одной из почтовых групп.
      adminGroups.push(newItem)
    }
  })

  adminGroups.forEach((group) => group.users.forEach(({ user }) => addUser(user, [0])))

  groupsAndUsers?.users_not_in_groups?.forEach((user) => addUser(user, [0]))

  return items
}
